"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var react_1 = __importStar(require("react"));
var calendar_store_1 = require("./calendar-store");
var number_mask_1 = require("./number-mask");
var calendar_1 = require("./calendar");
var utils_1 = require("./utils");
function DatePickerContent(_a) {
    var date = _a.date, onChange = _a.onChange, isTimePicker = _a.isTimePicker, placeholder = _a.placeholder, timeOnly = _a.timeOnly, styleName = _a.styleName;
    var _b = (0, react_1.useContext)(calendar_store_1.DatePickerContext), state = _b.state, dispatch = _b.dispatch;
    var _c = (0, react_1.useState)("d-none"), className = _c[0], setClass = _c[1];
    var ref = (0, react_1.useRef)(null);
    var divRef = (0, react_1.useRef)(null);
    (0, number_mask_1.useNumberMask)({ ref: ref, mask: timeOnly ? "time" : (isTimePicker ? "datetime" : "date") });
    (0, react_1.useEffect)(function () {
        dispatch({ type: "onChange", payload: onChange });
        dispatch({ type: "setTimePicker", payload: isTimePicker });
        if (timeOnly)
            return dispatch({ type: "setDateString", payload: date });
        var newDate = (0, utils_1.parseDate)(date, state.date);
        dispatch({ type: "setDateString", payload: date });
        if (newDate) {
            dispatch({ type: "setDate", payload: newDate });
            dispatch({ type: "setSelected", payload: newDate });
        }
    }, [date, onChange, isTimePicker]);
    (0, react_1.useEffect)(function () {
        if (state.open) {
            setClass('fade');
            setTimeout(function () { return setClass('fade show'); }, 60);
            return;
        }
        setClass('fade');
        setTimeout(function () { return setClass('d-none'); }, 300);
    }, [state.open]);
    var open = (0, calendar_store_1.useOpen)();
    var hide = (0, calendar_store_1.useHide)();
    (0, react_1.useEffect)(function () {
        if (!state.open)
            return;
        function handle(ev) {
            if (ref.current == ev.target)
                return;
            if (divRef.current != null && (divRef.current == ev.target || divRef.current.contains(ev.target)))
                return;
            hide();
        }
        document.addEventListener("click", handle);
        document.addEventListener("focus", handle, true);
        return function () {
            document.removeEventListener("click", handle);
            document.removeEventListener("focus", handle, true);
        };
    }, [state.open]);
    return react_1.default.createElement("div", { className: "date-picker ".concat(styleName || "") },
        react_1.default.createElement("input", { className: "form-control d-inline-block me-2", onFocus: open, style: { maxWidth: timeOnly ? "120px" : "300px" }, ref: ref, value: date || "", onChange: function (e) { return onChange(e.target.value); }, placeholder: placeholder }),
        react_1.default.createElement(calendar_1.Calendar, { divRef: divRef, className: className, timeOnly: timeOnly }));
}
function DatePicker(props) {
    return react_1.default.createElement(calendar_store_1.DatePickerStore, null,
        react_1.default.createElement(DatePickerContent, __assign({}, props)));
}
exports.DatePicker = DatePicker;
//# sourceMappingURL=DatePicker.js.map